export default __webpack_public_path__ + "static/media/qryape.6fc2ef4f.png";